import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import createConfigurableGridViewModel, {
  ViewModelType
} from '../../ConfigurableGrid/configurable-grid-view-model';
import ConfigurableGridView from '../../ConfigurableGrid/ConfigurableGridView';

const PREFIX = 'RelatedElementsContent';

const classes = {
  relatedElementsHeader: `${PREFIX}-relatedElementsHeader`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.relatedElementsHeader}`]: {
    paddingLeft: theme.spacing(2)
  }
}));

interface Props {
  elementId: string;
  viewDefinitionId: string;
}

const RelatedElementsContent = ({ elementId, viewDefinitionId }: Props) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(true);

  const iconOnClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    setIsExpanded(!isExpanded);
  };

  const viewModel: ViewModelType = createConfigurableGridViewModel({
    id: elementId,
    viewDefinitionId
  });

  return (
    <Root>
      <Typography
        className={classes.relatedElementsHeader}
        variant="subtitle1"
        color="primary"
        data-testid="related-elements-header"
      >
        Related elements
        <Tooltip title={isExpanded ? 'Collapse' : 'Expand'}>
          <IconButton size="small" aria-label="expand-related-elements" onClick={iconOnClick}>
            <ExpandMore transform={isExpanded ? 'rotate(180)' : 'rotate(0)'} />
          </IconButton>
        </Tooltip>
      </Typography>
      <Collapse
        data-testid="expanded-group"
        in={isExpanded}
        timeout={{ enter: 200, exit: 250 }}
        unmountOnExit
      >
        <ConfigurableGridView viewModel={viewModel} />
      </Collapse>
    </Root>
  );
};

export default RelatedElementsContent;
